import { SearchDocumentType, } from '../../api/api.types';
import { getDemoSearchResults } from './searchResults';
import { getTotalCount } from './getTotalCount';
const PAGE_SIZE = 10;
const SEARCH_RESULTS_EMPTY_RESPONSE = {
    documents: [],
    nextPage: { total: 0, skip: 0, limit: PAGE_SIZE },
    facets: [],
};
const FACETS = [
    {
        minAggregation: {
            facet: 'discountedPriceNumeric',
            minValue: 0,
        },
    },
    {
        maxAggregation: {
            facet: 'discountedPriceNumeric',
            maxValue: 999,
        },
    },
    {
        terms: {
            facet: 'collections',
            facets: [
                {
                    facetValue: 'searchSuggestions.filters.category.All',
                    count: 6,
                },
                {
                    facetValue: 'searchSuggestions.filters.category.1',
                    count: 5,
                },
                {
                    facetValue: 'searchSuggestions.filters.category.2',
                    count: 4,
                },
            ],
        },
    },
];
export function getDemoSearchResponse(searchRequest, { shouldHaveSearchResults, useRawProductDocuments }) {
    if (!shouldHaveSearchResults) {
        return SEARCH_RESULTS_EMPTY_RESPONSE;
    }
    const documentType = searchRequest.documentType || SearchDocumentType.All;
    const totalCount = getTotalCount(documentType);
    const skip = (searchRequest.paging && searchRequest.paging.skip) || 0;
    const limit = Math.min(totalCount - skip, (searchRequest.paging && searchRequest.paging.limit) || PAGE_SIZE);
    return {
        documents: getDemoSearchResults({
            documentType,
            limit,
            skip,
            query: searchRequest.query,
            useRawProductDocuments,
        }),
        nextPage: { total: totalCount, skip: 0, limit },
        facets: documentType === SearchDocumentType.Products ? FACETS : [],
    };
}
//# sourceMappingURL=searchResponse.js.map